import { Divider as DividerMantine } from '@mantine/core'
import styled, { createGlobalStyle } from 'styled-components'

export const Divider = styled(DividerMantine)`
  border-top-color: ${({ theme }) => theme.divisoria} !important;
`

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
  }
`
